import {endsWith, isBlank} from '../utils/stringUtils';
import {isNullish} from '../utils/Utils';

import {MIMETypes} from './MIMETypes';

export enum StreamTypes {
  dash = 'dash',
  hls = 'hls',
  prog = 'progressive',
}

export function getStreamTypesFromURL(url: string | undefined): StreamTypes | undefined {
  if (isNullish(url) || isBlank(url)) {
    return undefined;
  }

  const urlPath = url.split(/[?#]/)[0].toLowerCase();

  if (endsWith(urlPath, '.m3u8')) {
    return StreamTypes.hls;
  }
  if (endsWith(urlPath, '.mp4') || endsWith(urlPath, '.m4v') || endsWith(urlPath, '.m4a')) {
    return StreamTypes.prog;
  }
  if (endsWith(urlPath, '.webm')) {
    return StreamTypes.prog;
  }
  if (endsWith(urlPath, '.mpd')) {
    return StreamTypes.dash;
  }

  return undefined;
}

export function getStreamTypeFromMIMEType(mimeType: string): StreamTypes | undefined {
  const MIME_TYPE_TO_STREAM_TYPE_MAP = {
    [MIMETypes.MP4]: StreamTypes.prog,
    [MIMETypes.WEBM]: StreamTypes.prog,
    [MIMETypes.HLS]: StreamTypes.hls,
    [MIMETypes.DASH]: StreamTypes.dash,
  };

  return MIME_TYPE_TO_STREAM_TYPE_MAP[mimeType];
}
